import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { forwardRef } from 'react';

type RequiredLabelProps = React.HTMLAttributes<HTMLSpanElement>;

export const RequiredLabel = forwardRef<HTMLSpanElement, RequiredLabelProps>(
  ({ ...props }, ref) => {
    const { t: tCommons } = useTranslationWithLang('commons');
    return (
      <span
        className="bg-[#d42323] font-bold text-[--c-button-text] px-2 rounded-full border border-white"
        aria-hidden="false"
        role="text"
        {...props}
        ref={ref}
      >
        {tCommons('TU000_081')}
      </span>
    );
  }
);
RequiredLabel.displayName = 'RequiredLabel';
